export default __webpack_public_path__ + "static/media/check_circle.97e5b90a.svg";